import { Box, SxProps } from "@mui/material";

export const defaultIconSx = {
  height: "auto",
  display: "flex",
  alignItems: "center",
  alignSelf: "center",
  "& svg": {
    width: "36px",
    height: "auto",
  },
};

export function IconLink({ sx }: { sx?: SxProps }) {
  return (
    <Box
      sx={{
        ...defaultIconSx,
        ...sx,
      }}
    >
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 36 36"
        xmlSpace="preserve"
      >
        <g>
          <path
            fill="#A652A0"
            d="M4,0h28c2.2,0,4,1.8,4,4v28c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V4C0,1.8,1.8,0,4,0z"
          />
          <path
            fill="#FFFFFF"
            d="M9.9,18c0-1.7,1.4-3.1,3.1-3.1l0,0h4V13h-4c-2.8,0-5,2.2-5,5s2.2,5,5,5h4v-1.9h-4
		C11.3,21.1,9.9,19.7,9.9,18L9.9,18z M14,19h8v-2h-8V19z M23,13h-4v1.9h4c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c0,0,0,0,0,0
		h-4V23h4c2.8,0,5-2.2,5-5S25.8,13,23,13z"
          />
        </g>
      </svg>
    </Box>
  );
}

export function IconConnect({ sx }: { sx?: SxProps }) {
  return (
    <Box
      sx={{
        ...defaultIconSx,
        ...sx,
      }}
    >
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 36 36"
        xmlSpace="preserve"
      >
        <g>
          <path
            fill="#445BAB"
            d="M4,0h28c2.2,0,4,1.8,4,4v28c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V4C0,1.8,1.8,0,4,0z"
          />
          <path
            fill="#FFFFFF"
            d="M9.4,13.5h4.1v14.1H9.4V13.5z M16,7.7H20v20H16V7.7z M22.5,17.3h4.1v10.3h-4.1V17.3z"
          />
        </g>
      </svg>
    </Box>
  );
}

export function IconActivate({ sx }: { sx?: SxProps }) {
  return (
    <Box
      sx={{
        ...defaultIconSx,
        ...sx,
      }}
    >
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 36 36"
        xmlSpace="preserve"
      >
        <g>
          <path
            fill="#00AF4A"
            d="M4,0h28c2.2,0,4,1.8,4,4v28c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V4C0,1.8,1.8,0,4,0z"
          />
          <path
            fill="#FFFFFF"
            d="M16.9,8L8.6,28H11l2.3-5.7l0.7-1.9l4.1-10l4,10l0.7,1.9L25,28h2.4L19.1,8H16.9z"
          />
        </g>
      </svg>
    </Box>
  );
}
